import { EmbedBlock } from "graphql/generated-types";
import React from "react";

const EmbedBlock = ({ block }: { block: EmbedBlock }) => {
	return (
		<div className="container">
			<div className="responsive-object aspect-video" dangerouslySetInnerHTML={{ __html: block.embed! }} />
		</div>
	);
};

export default EmbedBlock;
